module.exports = "/_next/static/images/95e2942eac2cf836c13bf2e18f4eb98d-hero-xs.jpg";